import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface SitOnTableButtonProps {
    size?: 'small' | 'medium' | 'large';
    onClick?: () => void;
    className?: string;
}

const sizeConfig = {
    small: { width: 60, height: 60, fontSize: '10px', border: '1.2px' },
    medium: { width: 70, height: 70, fontSize: '10px', border: '2px' },
    large: { width: 86, height: 86, fontSize: '12px', border: '2px' },
};

const ButtonContainer = styled(Box)<{ size: 'small' | 'medium' | 'large' }>(({ size }) => ({
    width: sizeConfig[size].width,
    height: sizeConfig[size].height,
    borderRadius: '50%',
    backgroundColor: 'rgba(62, 65, 77, 0.75)',
    border: `${sizeConfig[size].border} solid rgba(255, 255, 255, 0.1)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: 'rgba(62, 65, 77, 0.9)',
    },
}));

const ButtonText = styled(Typography)<{ size: 'small' | 'medium' | 'large' }>(({ size }) => ({
    color: 'white',
    fontSize: sizeConfig[size].fontSize,
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: 1.2,
    userSelect: 'none',
}));

const SitOnTableButton: React.FC<SitOnTableButtonProps> = ({
    size = 'medium',
    onClick,
    className
}) => {
    const { t } = useTranslation('common');

    return (
        <ButtonContainer size={size} onClick={onClick} className={className}>
            <ButtonText size={size}>{t('labels.sitOnTable')}</ButtonText>
        </ButtonContainer>
    );
};

export default SitOnTableButton;
